import AddSingleMemberDropdown from 'components/CustomDropdown/AddSingleMemberDropdown';
import AssignSingleMemberDropdown from 'components/CustomDropdown/AssignSingleMemberDropdown';
import { useState } from 'react';

const TaskAssign = ({
  taskId,
  initialAssinee,
  organizationMembersList,
  updateTaskAssignee,
}) => {
  const onMemberSelect = newAssignee => {
    updateTaskAssignee({ task_id: taskId, data: newAssignee });
  };
  const clearMember = () => {
    // setAssignee(null);
  };
  return (
    <AssignSingleMemberDropdown
      assigneeManage={initialAssinee}
      updateState={onMemberSelect}
      membersList={organizationMembersList}
      clearAssignee={() => clearMember()}
    />
  );
};

export default TaskAssign;
